module.exports = __webpack_public_path__ + "img/logo.461512c0.png";